import classNames from 'classnames/bind';

import styles from './TestResults.module.scss';

const cx = classNames.bind(styles);

const TestResults = ({ color }) => {
  return (
    <ul className={cx('container')}>
      <li>
        <p className={cx('title')}>
          <span className={cx(['number', color])}>01</span>
          Hypoallergenic Dermatologically Tested <br />
          피부 저자극 테스트 완료
        </p>
        <img
          src={require('../../../asset/images/detail/common/test_result-01.png')}
          alt="Hypoallergenic Dermatologically Tested 피부 저자극 테스트 완료"
        />
        <p className={cx('desc')}>
          더진리에서 의뢰한 ‘르브레 로로밤_블루 외 3종’의 피부첩포에 의한 피부 일차 자극 평가에 대한 인체적용시험 결과, 판정기준에 따라
          무자극으로 도출되어 저자극 제품군에 속하는 것으로 판단된다.
        </p>
        <p className={cx('agency')}>(한국피부과학연구원)</p>
      </li>
      {color === 'blue' && (
        <li>
          <p className={cx('title')}>
            <span className={cx(['number', color])}>02</span>
            Hydration Improvement <br />
            피부 보습 개선
          </p>
          <img src={require('../../../asset/images/detail/common/test_result-bleu.png')} alt="Hydration Improvement 피부 보습 개선" />
        </li>
      )}
      {color === 'green' && (
        <li>
          <p className={cx('title')}>
            <span className={cx(['number', color])}>02</span>
            Skin Soothing Improvement <br />
            피부 진정 효과
          </p>
          <img src={require('../../../asset/images/detail/common/test_result-vert.png')} alt="Hydration Improvement 피부 보습 개선" />
        </li>
      )}
      {['pink', 'red'].includes(color) && (
        <li>
          <p className={cx('title')}>
            <span className={cx(['number', color])}>02</span>
            High Function & Herb Fragrance
          </p>
        </li>
      )}
    </ul>
  );
};

export default TestResults;
